import visitorConstants from "@/constants/visitorConstants"
import queueConstants from "@/constants/queueConstants"
import axios from "axios"
import retainExtraPassesConstants from "@/constants/retainExtraPassesConstants"

const state = {}

const getters = {}

const mutations = {}

const actions = {
  updateAppointmentPassModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/1`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateKioskModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/3`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateIdCardModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/4`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateTardyModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/5`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  toggleModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/${data.id}/status`, data.moduleStatus)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  clearTardyModuleData() {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/admin/modules/tardy/clear`, {})
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateVisitorModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/${visitorConstants.VISITOR_MODULE_ID}`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateQueueModule(context, status) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/${queueConstants.QUEUE_MODULE_ID}/status`, {
          status
        })
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateRetainExtraPasses(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/admin/modules/${retainExtraPassesConstants.RETAIN_EXTRA_PASSES_MODULE_ID}/status`,
          {
            status: data.retainExtraPasses
          }
        )
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateLogoutOvernightModule(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/modules/10`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
